import { render, staticRenderFns } from "./Command.vue?vue&type=template&id=e6b65cf4"
import script from "./Command.vue?vue&type=script&setup=true&lang=ts"
export * from "./Command.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports